import { getAgeRanges } from '@/services/AgeRangeService'

export default {
  state: {
    ageRangesList: [],
    ageRangesListError: null,
    ageRangesListLoading: false
  },

  mutations: {
    setAgeRangesList(state, ranges) {
      state.ageRangesList = ranges
    },
    setAgeRangesListError(state, error) {
      state.ageRangesListError = error
    },
    setAgeRangesListLoading(state, status) {
      state.ageRangesListLoading = status
    }
  },

  actions: {
    async getAgeRangesList({ commit }) {
      commit('show', { element: 'fullPageLoader' })
      commit('setAgeRangesListLoading', true)
      try {
        const response = await getAgeRanges()
        commit('setAgeRangesList', response.data)
      } catch (error) {
        commit('setAgeRangesListError', error)
      }
      commit('setAgeRangesListLoading', false)
      commit('hide', { element: 'fullPageLoader' })
    }
  }
}
